module.exports = __webpack_public_path__ + "static/media/location-gris.c7bb95ec.svg";